import React, { ChangeEvent, memo } from 'react';

import { FormControl, FormHelperText, makeStyles } from '@material-ui/core';
import { Field, FieldProps } from 'formik';
import { Translate } from 'react-localize-redux';

import { formikValidate } from '../../../helpers/validation';
import Spacer from '../../../ui/Spacer';
import TextField from '../../../ui/TextField/TextField';
import EditWebsiteSettingsUploadImage from './EditWebsiteSettingsUploadImage';

type Props = OuterProps;

type OuterProps = {
  image: any;
  title: string;
  content: string;
  titleFieldName: string;
  imageFieldName: string;
  contentFieldName: string;
  errors: any;
};

const useStyles = makeStyles({
  content: {
    padding: '20px 12px',
    border: '1px solid #c4c4c4',
    borderTop: 0,
  },
});

const validate = (image?: File, title?: string, content?: string) => {
  return formikValidate.oneOf([image, title, content], ['image', 'title', 'content']);
};

const validateText = (content: string) => {
  return formikValidate.containsHTMLElement(content);
};

const validateImage = (image?: File, title?: string, content?: string) => {
  return (
    (image && image instanceof File && formikValidate.extension(image, ['png', 'jpeg', 'jpg'])) ||
    validate(image, title, content)
  );
};

export default memo(function EditWebsiteSettingsAboutSectionItem(props: Props) {
  const { titleFieldName, contentFieldName, imageFieldName, title, content, image, errors } = props;
  const classes = useStyles();

  return (
    <div>
      <Field name={imageFieldName} validate={(value) => validateImage(value, title, content)}>
        {(fProps: FieldProps) => {
          const { field, form } = fProps;
          return (
            <FormControl fullWidth>
              <EditWebsiteSettingsUploadImage
                fdKey={`about_sections_image_${imageFieldName}`}
                image={
                  field.value && typeof field.value === 'object' ? field.value.ImageUrl : undefined
                }
                onChange={(files: FileList | null) => {
                  form.setFieldValue(field.name, files ? files[0] : null);
                }}
              />
            </FormControl>
          );
        }}
      </Field>
      <div className={classes.content}>
        {errors[imageFieldName] && <FormHelperText error>{errors[imageFieldName]}</FormHelperText>}
        <Spacer size={16} />
        <Field name={titleFieldName} validate={(value: string) => validateText(value)}>
          {(fProps: FieldProps) => {
            const { field, form } = fProps;
            return (
              <FormControl fullWidth>
                <TextField
                  fdKey={`about_section_title_${titleFieldName}`}
                  value={field.value || ''}
                  label={
                    <Translate
                      id={
                        `About_section_${
                          titleFieldName.includes('Left') ? 'left' : 'right'
                        }_title` as TranslationId
                      }
                    />
                  }
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    form.setFieldValue(field.name, e.target.value)
                  }
                />
                <FormHelperText error>{errors[titleFieldName]}</FormHelperText>
              </FormControl>
            );
          }}
        </Field>
        <Spacer size={16} />
        <Field name={contentFieldName} validate={(value: string) => validateText(value)}>
          {(fProps: FieldProps) => {
            const { field, form } = fProps;
            return (
              <FormControl fullWidth>
                <TextField
                  fdKey={`about_section_content_${contentFieldName}`}
                  value={field.value || ''}
                  label={
                    <Translate
                      id={
                        `About_section_${
                          titleFieldName.includes('Left') ? 'left' : 'right'
                        }_content` as TranslationId
                      }
                    />
                  }
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    form.setFieldValue(field.name, e.target.value)
                  }
                />
                <FormHelperText error>{errors[contentFieldName]}</FormHelperText>
              </FormControl>
            );
          }}
        </Field>
      </div>
    </div>
  );
});
